import request from '../utils/request'

//企业管理员查看所有合同
export function allContracts(contract_type,limit,page) {
    return request.post('/api/comadmin_contract_list',{"contract_type":contract_type,"limit":limit,"page":page})
}
//企业管理员查看所有合同 搜索
export function allContractsSearch(contract_type,limit,page,doc_title,signer) {
    return request.post('/api/comadmin_contract_list',{"contract_type":contract_type,"limit":limit,"page":page,"doc_title":doc_title,"signer":signer})
}
//企业管理员查看所有合同 作废
export function voidContract(contract_id) {
    return request.post('/api/contadmin_sign_flow_revoke',{"contract_id":contract_id})
}
//企业管理员查看所有合同 下载
export function downloadContract(contract_id) {
    return request.post('/api/contadmin_download_one',{"contract_id":contract_id})
}
//企业管理员查看所有合同 合同上传清单详情
export function UploadListDetails(contract_id) {
    return request.post('/api/contadmin_evidence_detail',{"contract_id":contract_id})
}
//企业管理员查看所有合同 合同上传清单详情 保存证据
export function preservedMaterial(contract_id,evidence_data) {
    return request.post('/api/contadmin_save_evidence',{"contract_id":contract_id,"evidence_data":evidence_data})
}
//企业管理员查看所有合同 转入仲裁信息展示
export function arbitrationMessage(contract_id) {
    return request.post('/api/contadmin_to_zhcai_detail',{"contract_id":contract_id})
}
//企业管理员查看所有合同 转入仲裁信息 保存
export function saveInformation(contract_id,zhcai_type,doc_title,contract_sn,sign_time,qingqiu,liyou,signers) {
    let obj={
        "contract_id":contract_id,
        "zhcai_type":zhcai_type,
        "doc_title":doc_title,
        "contract_sn":contract_sn,
        "sign_time":sign_time,
        "qingqiu":qingqiu,
        "liyou":liyou,
        "signers":signers
    }
    return request.post('/api/contadmin_to_zhcai_save',obj)
}
//企业管理员查看所有合同  发起失败 删除
export function failureFile(contract_id) {
    return request.post('/api/contadmin_sign_delete',{"contract_id":contract_id})
}
//企业管理员 延期签署
export function deferredSignature(data) {
    return request({
        url:'/api/contadmin_sign_delay',
        method:'post',
        data
    })
}
//绑定合同证据清单 管理员绑定
export function bindContractEvidence(data) {
    return request({
        url:'/api/batch_hetongadmin_bind_evi',
        method:'post',
        data
    })
}
